import catalogue from './data/pack-catalogue.json';

export const territoryCatalogue = catalogue.communes;

export function readTestTerritory(search = window.location.search): { codes: string[]; error: string | null } {
  const params = new URLSearchParams(search);
  const values = params.getAll('territoires');
  if (!values.length) return { codes: [], error: null };
  const codes = values[0].split(',');
  if (values.length !== 1 || codes.some(code => !territoryCatalogue.some(c => c.insee === code))) {
    return { codes: [], error: 'Le lien contient un territoire inconnu. Choisissez les communes du test ci-dessous.' };
  }
  return { codes: [...new Set(codes)].sort(), error: null };
}

export function testTerritoryUrl(codes: string[]): string {
  const url = new URL(window.location.href);
  url.searchParams.delete('configuration');
  url.searchParams.set('territoires', [...new Set(codes)].sort().join(','));
  return url.href;
}
